import 'reflect-metadata';
import { container } from 'tsyringe';
import { RequestInterceptor } from '@/Http';
import { AuthService } from '@/Services';

export const authorizationHandler: RequestInterceptor = {
    async onFulfilled(request) {
        if (request.headers) {
            request.headers['Authorization'] =
                'Bearer ' + (await container.resolve<AuthService>(AuthService).getAccessToken());
        }
        return request;
    },
};
